import { memo, useEffect, useState } from "react";
import { Alert } from "@mui/material";
import PageLayout from "../../../../components/PageLayout";
import { useUserProfileInfo } from "../../hooks/useUserInfo";
import { UserPersonalInfoBlock } from "../../components/UserInfoAccordion";
import { PasswordChangeBlock } from "../../components/PasswordChangeAccordion";
import { useUpdateCurrentUser } from "../../hooks/useUpdateCurrentUser";
import { useCompaniesList } from "../../../company/hooks/useCompaniesList";
import { UserCompaniesBlock } from "../../components/CompaniesBlock";

export const UserProfileScreen = memo(() => {
  const [data] = useCompaniesList();
  const [
    { userInfo, userCompanies },
    loadingProfile,
    profileError,
    getUserInfo,
  ] = useUserProfileInfo(data);
  const [
    updateCurrentUser,
    updatingProfile,
    updateCurrentUserError,
    updateCurrentUserRequest,
  ] = useUpdateCurrentUser();
  const [userInfoResult, setUserInfoResult] = useState(false);

  const onSubmitUserInfo = (name: string) => {
    try {
      updateCurrentUserRequest(name);
      setUserInfoResult(true);
      setTimeout(() => {
        setUserInfoResult(false);
      }, 3000);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (updateCurrentUser) {
      getUserInfo();
    }
  }, [updateCurrentUser, getUserInfo]);

  return (
    <PageLayout loading={loadingProfile} title='Profile settings'>
      {profileError !== null && (
        <Alert severity='error'>{profileError.toString()}</Alert>
      )}
      <UserPersonalInfoBlock
        onSubmitUserInfo={onSubmitUserInfo}
        userInfoResult={userInfoResult}
        userInfo={userInfo}
        error={updateCurrentUserError}
        isLoading={updatingProfile}
      />
      <PasswordChangeBlock userInfo={userInfo} />
      {userCompanies && (
        <UserCompaniesBlock
          companies={userCompanies}
          userId={userInfo?.userId}
        />
      )}
    </PageLayout>
  );
});
